<template>
  <div class="d-flex align-items-center justify-content-center h-100">
    <b-card class="strong-shadow text-center p-4" no-body>
      <div class="m-auto mt-5 mb-5">
        <img src="@/assets/img/auto_atendimento/veusinho-okay.png" width="150" alt="">
      </div>
      <h1 class="title mt-4">{{ $t('auto_atendimento.qr.obrigado') }}<br>{{ $t('auto_atendimento.autoatendimento') }}
      </h1>

      <qrcode-vue v-if="url" class="qr-code mb-4" :size="500" :value="`${url}`"/>

      <p>{{ $t('auto_atendimento.qr.explicacao') }}</p>
      <p class="mb-4">
        {{ $t('auto_atendimento.qr.parafazer') }}
        <router-link :to="{ name: 'vaa.orcamento.show', params: { id: $route.params.id }}">
          {{ $t('auto_atendimento.qr.cliqueaqui') }}
        </router-link>
        {{ $t('auto_atendimento.qr.faleconosco') }} (21) 3005 3702
      </p>

      <b-button variant="outline-warning" @click="$router.push({name: 'vaa.index'})">
        {{ $t('auto_atendimento.qr.voltar') }}
      </b-button>
    </b-card>
  </div>
</template>

<script>
import qrcodeVue from 'qrcode-vue'

export default {
  name: "QRCode",
  components: {qrcodeVue},
  computed: {
    url() {
      if (this.$route.params.id) {
        return `${window.location.protocol}//${window.location.hostname}/auto_atendimento/orcamento/${this.$route.params.id}`
      }

      return null
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .title {
    font-size: xx-large;
  }
}

::v-deep.qr-code {
  img {
    width: 75%;
    border: #f9b112 5px solid;
    border-radius: 10px;
    padding: 1rem;
  }

  canvas {
    width: 75%;
  }
}
</style>
